import type { FunctionComponent } from 'react';

import AlternatingText from 'components/AlternatingText';
import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import usePaidByCard from './usePaidbyCard';

const PaidByCard: FunctionComponent = () => {
  const { subtitleArray, line2 } = usePaidByCard();
  return (
    <PleaseWaitOverlay
      icon="check-circle-color"
      title="We have successfully received your card payment"
      labelLine1={<AlternatingText array={subtitleArray} />}
      labelLine2={line2}
    />
  );
};

export default PaidByCard;
